import React from "react";
import { Link } from "react-router-dom";
import prelogin from "../assets/prelogin.png";
import { openUrl } from "../utils/helpPlan";

function CardConsulting() {
  return (
    <div className="border-primary bg-primary px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto flex flex-col md:flex-row items-center md:items-stretch">
      {/* Texto (lado esquerdo no desktop, acima no mobile) */}
      <div className="md:w-1/2 w-full flex flex-col justify-center items-center md:items-start text-center md:text-left text-white px-4 mb-8 md:mb-0">
        <h1 className="text-3xl sm:text-4xl font-bold mb-4">
          Precisa de Consultoria para atendimento em disfagia?
        </h1>
        <button
          onClick={openUrl}
          className="bg-pink-600 hover:bg-pink-700 text-white font-semibold py-3 px-6 rounded-lg"
        >
          Clique aqui e Agende conosco
        </button>
      </div>

      {/* Imagem (lado direito no desktop, abaixo no mobile) */}
      <div className="md:w-1/2 w-full flex justify-center">
        <img
          src={prelogin}
          alt="Descrição do aplicativo"
          className="w-full max-w-md object-contain"
        />
      </div>
    </div>
  );
}

export default CardConsulting;
